import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { Course, Module, Content } from 'src/app/models/course.model';
// import { Store } from 'store';
import { Subscription } from 'rxjs/internal/Subscription';
// import { User } from 'src/app/models/user.model';
// import { CourseService } from 'src/app/services/course.service';
// import { DashboardService } from 'src/app/services/dashboard.service';
import * as screenfull from 'screenfull';
// import { config } from 'src/app/config';
import { Router } from '@angular/router';
import { User } from 'src/app/shared/models/user.model';
import { Content, Course, Module } from 'src/app/shared/models/course.model';
import { Store } from 'src/app/core/store/store';
import { CourseService } from 'src/app/shared/services/course.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { HabitDrillsService } from 'src/app/modules/habit-drills/services/habit-drills.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { CommonService } from 'src/app/shared/services/common.service';
// declare var amplitude;
declare var mixpanel;

@Component({
  selector: 'app-course-progress',
  templateUrl: './course-progress.component.html',
  styleUrls: ['./course-progress.component.css']
})
export class CourseProgressComponent extends HandleSubscription implements OnInit {

  subscription: Subscription;
  modules = [];
  @Input() user: User = null;
  @Input() currentUserCourse = null;
  @Output() hideWalkthrough = new EventEmitter();
  @Output() hideCourseProgress = new EventEmitter();
  @Output() viewedCertificate = new EventEmitter();
  @Output() sideBarClicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  lastVisitedContentId = null;
  completedContents = [];
  pendingScores = false;
  evaluationResult: any;
  @Input() courseId: string;
  @Input() config;
  @Input() course;
  userStatus = {
    line2: '',
    line3: ''
  };
  gridResult: any = {
    SKILL: 'HIGH',
    EFFORT: 'MEDIUM',
    CONFIDENCE: 'LOW'
  }
  totalPercentage = 0;
  course2Points = 0;
  totalPoints = 0;
  rows: any[] = [{ level: 'HIGH' }, { level: 'MEDIUM' }, { level: 'LOW' }]
  cells: any[] = [{ parameter: 'SKILL' }, { parameter: 'EFFORT' }, { parameter: 'CONFIDENCE' }];
  recommendedCourses: Course[] = []
  emojiReactions = {
    'HIGH': 'assets/images/emoticon-laugh.svg',
    'MEDIUM': 'assets/images/emoticon-smile.svg',
    'LOW': 'assets/images/emoticon-sad.svg'
  }
  inCompleteExercises: {
    id: string
    title: string
    moduleNumber: number
    moduleName: string
    sequenceNumber: number
  }[]
  inCompleteContents: {
    id: string
    title: string
    moduleNumber: number
    moduleName: string
    sequenceNumber: number
  }[]
  showPathwayBtn = false;
  pathwayName = '';
  @Input() pathway;
  @Input() activationData;
  activationInfo: any
  nextBtn = false;
  habitDrillSection = false;
  habitDrillTitle = '';
  showHidePopupModal = false;
  dynamicHabitDrillNomenclature= 'Habit Drill';

  constructor(private store: Store, private courseService: CourseService, private dashboardService: DashboardService, private router: Router,
    private toaster: ToastrService, private habitService: HabitDrillsService, private eventsService: EventsService, private cs: CommonService) {
    super();
  }

  async ngOnInit() {
    await this.getProgramActivationInfo();

    this.store.select('currentUserCourse').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if (data) {
        this.currentUserCourse = data;
      }
    })
    this.checkPathwayCourse();
    this.initialize();

    // capture event
    try {
      if (this.currentUserCourse.progress == 100) {
        if(this.user && this.currentUserCourse && this.activationData) {
          let eventData = { 'user': this.user, 'course': this.currentUserCourse, 'activationData': this.activationData };
          this.eventsService.viewCourseCompletionEvent(eventData);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  initialize() {

    this.modules = [];
    for (let cont of this.course.contents) {
      let i = this.modules.findIndex(g => g.moduleNumber == cont.moduleNumber);
      (i >= 0 && this.modules[i].contents.push(cont.contentInfo)) || this.modules.push({ moduleName: cont.moduleName, moduleNumber: cont.moduleNumber, contents: [cont.contentInfo] })
    }
    this.modules = this.modules.sort((a, b) => a.moduleNumber - b.moduleNumber);

    this.lastVisitedContentId = this.currentUserCourse.lastVisitedContent;
    this.completedContents = this.currentUserCourse.contentsCompleted;
    this.pendingScores = this.currentUserCourse.exercises.some(el => el.status != 'PUBLISHED' && el['assessmentType'] == 'TA_GRADED');
    this.setUserStatus();

    if (this.currentUserCourse.progress) {
      this.courseCompletion()
    }

  }

  isModuleCompleted({ contents }: Module) {
    if (this.currentUserCourse.progress == 100) return true;
    if (contents.length) {
      return contents.every(ct => this.completedContents.includes(ct._id));
    }
    return false;
  }

  isContentCompleted(contentId) {
    if (this.currentUserCourse.progress == 100) return true;
    return this.completedContents.includes(contentId);
  }

  setUserStatus() {
    if (this.currentUserCourse.progress <= 40) {
      this.userStatus.line2 = `Congratulations on starting ${this.toTitleCase(this.course.title)}!`;
      this.userStatus.line3 = `Here is what you need to complete to unlock your Harappa Certificate.`;
    } else if (this.currentUserCourse.progress > 40 && this.currentUserCourse.progress <= 85) {
      this.userStatus.line2 = `You’re halfway there. Kudos on coming this far.`;
      this.userStatus.line3 = `Here is what you need to complete to unlock your Harappa Certificate.`;
    } else if (this.currentUserCourse.progress > 85 && this.currentUserCourse.progress < 100) {
      this.userStatus.line2 = `You’re almost at the end. Keep going.`;
      this.userStatus.line3 = `Here is what you need to complete to unlock your Harappa Certificate.`
    } else if (this.currentUserCourse.progress == 100) {
      this.userStatus.line2 = `Congratulations on completing this course.`;
    }
  }

  courseCompletion() {

    this.dashboardService.courseCompleted(this.courseId, this.currentUserCourse.programActivationId).subscribe(res => {
      if (res) {
        res.contents && (this.inCompleteContents = Object.values(res.contents));
        res.exercises && (this.inCompleteExercises = Object.values(res.exercises));
        if (!this.inCompleteExercises.length) {
          this.getEvaluationData();
        }
      }
    });
  }



  getEvaluationData() {
    // commneted not being used in IPJ
    // this.courseService.evaluateCourse(this.courseId).subscribe(result => {
    //   if (result && result.courseProgress) {
    //     this.evaluationResult = result.courseProgress;
    //     this.totalPercentage = this.evaluationResult['totalPercentage'];
    //     this.course2Points = this.evaluationResult['points'];
    //     this.totalPoints = 0;
    //     for (let k in result.marks.marksByExercise) {

    //       this.totalPoints += Math.round(result.marks.marksByExercise[k].gainedMarks)
    //     }
    //     if (this.evaluationResult.isNewEvaluation) {
    //       this.gridResult['SKILL'] = this.evaluationResult.skillLevel
    //       this.gridResult['EFFORT'] = this.evaluationResult.effortLevel
    //       this.gridResult['CONFIDENCE'] = this.evaluationResult.confidenceLevel
    //     }
    //   }
    // });
  }

  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  goToContent(content) {
    this.play(content);
  }

  play(content: Content) {
    if (screenfull.enabled && screenfull.isFullscreen) {
      screenfull.exit();
    }
    if (this.courseService.currentItem === content._id) {
      this.hideWalkthrough.emit();
      return;
    }
    this.courseService.setcurrentPlayedItem(content._id);
    this.sideBarClicked.emit(true);
    this.hideWalkthrough.emit();
    this.hideCourseProgress.emit();
  }

  openCertificate() {
    if (this.currentUserCourse.certificateInfo && this.currentUserCourse.certificateInfo.certificateId) {
      this.viewedCertificate.emit(`/accomplishments/${this.currentUserCourse.certificateInfo.certificateId}`);
    }
    else {
      this.courseService.generateCertificate(this.config.courseId).subscribe(res => {
        if (res) {
          this.viewedCertificate.emit(`/accomplishments/${this.currentUserCourse.certificateInfo.certificateId}`);
        }
      });
    }
    this.amplitudeCertificateOpen();
  }

  amplitudeCertificateOpen() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization });
    amplitude.getInstance().logEvent('Course Completion', { 'Course Name': this.config.courseTitle, 'Course Score': this.totalPercentage }); */
    // mixpanel.track('View Certificate', { 'Course Name': this.course.templateName, 'Page Title':  document.title});
  }

  get checkThreshold() {
    if (!this.course.isNewEvaluation) {
      if (this.course.courseTypeVersion == "2") {
        if (this.course.threshold > this.course2Points) {
          return false;
        }
        return true;
      } else {
        if (this.course.threshold > this.totalPercentage) {
          return false;
        }
        return true;
      }
    } else {
      if (this.course.threshold > this.totalPoints) {
        return false;
      }
      return true;
    }
  }

  // In case of pathway user
  navigateToPathway() {
    this.router.navigate([`/pathways/${this.pathwayName}`]);
  }

  checkPathwayCourse() {
    for (let i = 0; i < this.user.cohorts.length; i++) {
      if (this.pathway && (this.pathway.templateName !== undefined) && this.user.cohorts[i].learningPathway && (this.pathway.templateName == this.user.cohorts[i].learningPathway.templateName) && (this.currentUserCourse.trait == this.user.cohorts[i].trait)) {
        this.showPathwayBtn = true;
        this.pathwayName = this.user.cohorts[i].learningPathway.templateName
        break;
      }
    }
  }

  /**
   * navigate to habit drill details page
   */
  habitDrillDetails() {
    let courseObj = this.activationData.find(v => v.courseId == this.courseId);
    if (courseObj) {
      this.router.navigateByUrl(`/dashboard/habit-drills/${courseObj.courseHabitDrills[0].courseHabitDrillId}`, { state: { reload: false }});
      // event capture
      try {
        if(this.user && this.activationData) {
          let eventData = { user: this.user, activationData: this.activationData, courseObj: courseObj }
          this.eventsService.habitDrillBeginEvent(eventData);
        }
      } catch (err) {
        console.log(err);
      }
    }
  }


  startZoom(item) {
    let meetingNum;
    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   this.toaster.info("Please log in through your laptop/desktop to access this session");
    //   return;
    // }
    if (item && item.url) {
      meetingNum = item.url.split('/');
      if (meetingNum[4].includes('?')) {
        meetingNum = meetingNum[4].split('?');
        meetingNum = meetingNum[0];
      } else {
        meetingNum = meetingNum[4];
      }
    }
    localStorage.setItem('email', this.user.email);
    localStorage.setItem('meetingId', meetingNum);
    localStorage.setItem('userName', `${this.user.firstName} ${this.user.lastName}`);
    localStorage.setItem('pathwayUrl', window.location.href);
    window.open(`/zoom-meeting`, '_blank');
  }

  showHideNextBtn() {
    let courseObj = this.activationData.find(x => x.status.islock == false && x.status.progress < 100 && x.type == 'COURSE' && x._id != this.courseId);
    let masterclassObj = this.activationData.find(x => x.status.islock == false && x.status.progress < 100 && x.type == 'MASTERCLASS' && !x.status.upcoming);
    let prePostObj = this.activationData.benchmarkingAssessments?.find(x => x.status.islock == false && x.status.progress < 100);
    
    // console.log(courseObj, 'this.activationDatathis.activationDatathis.activationData')
    if (!courseObj && !masterclassObj && !prePostObj) {
      this.nextBtn = false;
    } else {
      // console.log(this.currentUserCourse, 'this.currentUserCoursethis.currentUserCourse')
      if(this.currentUserCourse.progress == 100) {
        this.nextBtn = true;
        if((masterclassObj && !masterclassObj.status.isMeetingEnd) ||
        (masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== '')) {
        this.nextBtn = true;
      } else {
        (courseObj || prePostObj) ? this.nextBtn = true : this.nextBtn = false;
      }
      } else {
        this.nextBtn = false;
      }

    }
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  nextActiveItem() {
    if(this.activationInfo.isNewActivation) {
      localStorage.setItem('skipOptional', 'true');
      this.store.set('setFromCourseProgress', 'true')
      this.router.navigateByUrl(`/dashboard`, { state: { reload: true } });
      // this.cs.reloadRoute(`/dashboard`)
      this.captureClickNextEvent();
      return;
    }
    // let courseObj = this.activationData.find(x => x.status.islock == false && x.status.progress < 100 && x.type == 'COURSE' && x._id != this.courseId);
    // let masterclassObj = this.activationData.find(x => x.status.islock == false && x.status.progress < 100 && x.type == 'MASTERCLASS' && !x.status.upcoming);
    // let prePostObj = this.activationData.benchmarkingAssessments?.find(x => x.status.islock == false && x.status.progress < 100);

    // if (courseObj && !masterclassObj) {
    //   this.navigateToCouse(courseObj);
    // } else if (((masterclassObj && !masterclassObj.status.isMeetingEnd) ||
    //   (masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== ''))
    //   && !courseObj) {
    //   this.navigateToMasterclass(masterclassObj);
    // } else if (courseObj && masterclassObj) {
    //   if(((masterclassObj && !masterclassObj.status.isMeetingEnd) ||
    //     (masterclassObj && masterclassObj.status.isMeetingEnd && masterclassObj.recordedLink && masterclassObj.recordedLink !== ''))) {
    //     this.navigateToMasterclass(masterclassObj);
    //   } else {
    //     this.navigateToCouse(courseObj);
    //   }
    //   // (courseObj.order < masterclassObj.order) ? this.navigateToCouse(courseObj) : this.navigateToMasterclass(masterclassObj);
    // } else if (prePostObj && prePostObj.exerciseType == 'POST') {
    //   this.router.navigate([`/benchmarking/post-test`]);
    //   // this.captureClickNextEvent(prePostObj);
    // } else {
    //   this.nextBtn = false;
    // }
  }

  navigateToCouse(courseObj) {
    if (courseObj.status.started) {
      this.store.set('currentUserCourse', null);
      this.redirectTo(`/player/${courseObj.courseId}`);
      // this.router.navigateByUrl(`/player/${courseObj.courseId}`, { state: { reload: false }});
    } else {
      localStorage.setItem('playVideo', 'true');
      this.router.navigateByUrl(`/dashboard`, { state: { reload: false } });
    }
    this.captureClickNextEvent();
  }

  navigateToMasterclass(item) {
    localStorage.setItem('playVideo', 'true');
    this.router.navigateByUrl(`/dashboard`, { state: { reload: false } });
    this.captureClickNextEvent();
  }

  showHideHabitDrill() {
    let courseObj = this.activationData.find(v => v.courseId == this.courseId);
    if(courseObj && courseObj.courseHabitDrills && courseObj.courseHabitDrills.length) {
      this.getHabitDrillInfo(this.activationInfo.programActivationId, this.courseId, courseObj.courseHabitDrills[0].courseHabitDrillId);
      this.habitDrillSection = true;
    } else {
      this.habitDrillSection = false;
    }
  }

  getHabitDrillInfo(programactivationId ,courseId, habitDrillUuid){
    this.habitService.getHabitDrillInfo(programactivationId ,courseId, habitDrillUuid).subscribe((result) => {
      if(result['data']) {
        this.habitDrillTitle = result['data'].title;
      }
    }, error => {
     console.log(error);
   })
 }

 async getProgramActivationInfo() {
  let activationInfo = JSON.parse(localStorage.getItem('activationInfo'))
  let opts = {
    programActivationId: activationInfo.programActivationId,
    programId: activationInfo.programId
  }
  let res = await this.dashboardService.getActivationInfo(opts).toPromise();
    if(res && res['data']) {
      await this.getProgramActivation(activationInfo.programActivationId, activationInfo.programId)
      this.activationInfo = res['data'];
      if(this.activationInfo['enableCustomHabitDrillNomenClature']){
        this.dynamicHabitDrillNomenclature = this.activationInfo['customHabitNomenclature']
      }
    }
  }

  async getProgramActivation(programActivationId, programId) {
    let opts = {
      "programActivationId": programActivationId,
      "programId": programId,
      "userGroup": this.user?.userGroup
    }
    this.dashboardService.getActivationDashboard(opts).subscribe(res => {
      this.activationData = res.data

    this.showHideNextBtn();
    this.showHideHabitDrill();
      // this.store.set('programData', this.programData)
    })
  }

//  async getProgramActivation() {
//   let res = await this.dashboardService.getProgramActivation().toPromise();
//     if(res && res['data']) {
//       this.activationData = res['data'][0];
//       console.log(this.activationData)
//       if(this.activationData.program['activation']['enableCustomHabitDrillNomenClature']){
//         this.dynamicHabitDrillNomenclature = this.activationData['program']['activation']['customHabitNomenclature']
//       }
//     }
//   }

  showPopupModal() {
    this.showHidePopupModal = true;
    // capture event
    try {
      if (this.user && this.activationData && this.course ) {
        let eventData = { user: this.user, activationData: this.activationData, course: this.course }
        this.eventsService.habitDrillThriveSkillsEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }
  hidePopup(value) {
    this.showHidePopupModal = value;
  }

  //capture event click 'Next'
  captureClickNextEvent() {
    try {
      if(this.user && this.activationData) {
        let eventData = { user: this.user, activationData: this.activationData, source: 'Course' };
        this.eventsService.clickNextEvent(eventData);
      }
    } catch (err) {
      console.log(err);
    }
  }
}
